import axios from "axios";

import type { QueryCountResponse, SupportQueryResponse } from "../shared/interface/SupportQuery.interface";
import { ParamsObject } from "../shared/interface/parking.interface";

export const getAllSupportQueries = async (params: ParamsObject) => {
  try {
    let query = `${process.env.REACT_APP_API_URL}/query-feedback/list?page=${params.page}&pageSize=${params.pageSize}`;

    if (params.customerId) {
      query += `&customerId=${params.customerId}`;
    }

    if (params.locationId) {
      query += `&locationId=${params.locationId}`;
    }

    if (params.searchQuery) {
      query += `&searchQuery=${params.searchQuery}`;
    }

    const res = await axios.get(query);
    return res.data as SupportQueryResponse;
  } catch (error) {
    throw error;
  }
};

export const getAllOpenSupportQueryCount = async () => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/query-feedback/open-query-count`);
    return res.data as QueryCountResponse;
  } catch (error) {
    throw error;
  }
};

export const closeQuery = async (queryId: number) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/query-feedback/close/${queryId}`;

    const res = await axios.patch(url);
    return res.data;
  } catch (error) {
    throw error;
  }
};
